module.exports = __webpack_public_path__ + "img/medal1.cd109c16.png";